import React, { useState, useEffect } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { Link as LinkIcon, Type, Clock } from "lucide-react";

const MEAL_TYPES = [
    { id: 1, label: "Frühstück" },
    { id: 2, label: "Mittagessen" },
    { id: 3, label: "Abendessen" },
    { id: 4, label: "Snack/Anderes" },
];

const ManualEntryDialog = ({ show, onClose, onSave, initialDate, initialData }) => {
    const [title, setTitle] = useState("");
    const [link, setLink] = useState("");
    const [mealTimeId, setMealTimeId] = useState(2); // Default Lunch

    useEffect(() => {
        if (show) {
            if (initialData) {
                setTitle(initialData.notes || "");
                setLink(initialData.url || "");
                setMealTimeId(initialData.mealTimeCodeId || 2);
            } else {
                setTitle("");
                setLink("");
                setMealTimeId(2);
            }
        }
    }, [show, initialData]);

    const handleSave = () => {
        if (!title.trim()) return;
        onSave({
            id: initialData?.id,
            date: initialDate,
            title,
            link,
            mealTime: mealTimeId
        });
        onClose();
    };

    return (
        <Modal show={show} onHide={onClose} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{initialData ? "Eintrag bearbeiten" : "Manueller Eintrag"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Titel / Gericht <span className="text-danger">*</span></Form.Label>
                        <InputGroup>
                            <InputGroup.Text><Type size={18} /></InputGroup.Text>
                            <Form.Control
                                placeholder="z.B. Nudeln mit Pesto"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                autoFocus
                            />
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Link (Optional)</Form.Label>
                        <InputGroup>
                            <InputGroup.Text><LinkIcon size={18} /></InputGroup.Text>
                            <Form.Control
                                placeholder="https://chefkoch.de/..."
                                value={link}
                                onChange={(e) => setLink(e.target.value)}
                            />
                        </InputGroup>
                        <Form.Text className="text-muted">
                            Füge einen Link zum Rezept hinzu, um es später schnell zu öffnen.
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Mahlzeit</Form.Label>
                        <InputGroup>
                            <InputGroup.Text><Clock size={18} /></InputGroup.Text>
                            <Form.Select
                                value={mealTimeId}
                                onChange={(e) => setMealTimeId(Number(e.target.value))}
                            >
                                {MEAL_TYPES.map(type => (
                                    <option key={type.id} value={type.id}>{type.label}</option>
                                ))}
                            </Form.Select>
                        </InputGroup>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Abbrechen</Button>
                <Button variant="primary" onClick={handleSave} disabled={!title.trim()}>
                    Speichern
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ManualEntryDialog;
